import isEmpty from "validator/lib/isEmpty";

let isValid = true;

export const validateCreateBill = (input) => {
  let isValid = true;

  if (input.bill_no == undefined || isEmpty(input.bill_no)) {
    isValid = false;
  }

  return { isValid: isValid };
};

export const validateDestinationPackageService = (input) => {
  if (input.package_service === undefined || isEmpty(input.package_service)) {
    isValid = false;
  }
  return { isValid: isValid };
};
